var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner check-Criteria" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          staticStyle: { height: "100%" },
          attrs: { "body-style": { padding: "0px" } }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.ValidationCondition")))
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEditCheckRule,
                    expression: "isEditCheckRule"
                  }
                ]
              },
              [
                _vm.currOptStatus === _vm.optStatusDef.normal
                  ? [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showAdd }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Create")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                      ),
                      _c(
                        "el-button",
                        { attrs: { type: "danger" }, on: { click: _vm.del } },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                      )
                    ]
                  : [
                      _c(
                        "el-button",
                        { attrs: { type: "primary" }, on: { click: _vm.save } },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                      )
                    ]
              ],
              2
            )
          ]),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              style: {
                position: "relative",
                "min-height": "300px",
                height: _vm.isEdit ? "auto" : "100%"
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                staticClass: "pure-loading-mask"
              }),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEditCheckRule && _vm.currOptStatus,
                  expression: "isEditCheckRule && currOptStatus"
                }
              ],
              staticClass: "app-main-inner-row"
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "left", "label-width": "90px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Relation") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: !_vm.isEdit },
                          model: {
                            value: _vm.oneCheckCriteria.relation,
                            callback: function($$v) {
                              _vm.$set(_vm.oneCheckCriteria, "relation", $$v)
                            },
                            expression: "oneCheckCriteria.relation"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.And")))
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Or")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.FilterBasis") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { disabled: !_vm.isEdit },
                          model: {
                            value: _vm.oneCheckCriteria.filterDimension,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.oneCheckCriteria,
                                "filterDimension",
                                $$v
                              )
                            },
                            expression: "oneCheckCriteria.filterDimension"
                          }
                        },
                        _vm._l(_vm.filterDimensions, function(item) {
                          return _c("el-option", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filterCheckItems(
                                  _vm.checkRule.checkNode,
                                  item.code
                                ),
                                expression:
                                  "filterCheckItems(checkRule.checkNode, item.code)"
                              }
                            ],
                            key: item.code,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Operation") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { disabled: !_vm.isEdit },
                          model: {
                            value: _vm.oneCheckCriteria.operator,
                            callback: function($$v) {
                              _vm.$set(_vm.oneCheckCriteria, "operator", $$v)
                            },
                            expression: "oneCheckCriteria.operator"
                          }
                        },
                        _vm._l(_vm.operators, function(item) {
                          return _c("el-option", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filterOperators(
                                  _vm.oneCheckCriteria.filterDimension,
                                  item.code
                                ),
                                expression:
                                  "filterOperators(oneCheckCriteria.filterDimension, item.code)"
                              }
                            ],
                            key: item.code,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.FilterValue") }
                    },
                    [
                      _vm.oneCheckCriteria.filterDimension ===
                      _vm.customJobTypeCode
                        ? _c("cargo-cascader", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              "group-field": "type",
                              "method-params": { active: true },
                              "group-label-map": _vm.groupLabelMap,
                              "tag-value": "uuid"
                            },
                            model: {
                              value: _vm.oneCheckCriteria.filterValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckCriteria,
                                  "filterValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckCriteria.filterValue"
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.seaAirRegionCode
                        ? _c("cargo-cascader", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "tag-value": "code"
                            },
                            model: {
                              value: _vm.oneCheckCriteria.filterValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckCriteria,
                                  "filterValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckCriteria.filterValue"
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.railwayLineCode
                        ? _c("cargo-cascader", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayLine,
                              "tag-value": "code"
                            },
                            model: {
                              value: _vm.oneCheckCriteria.filterValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckCriteria,
                                  "filterValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckCriteria.filterValue"
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.feeNameCode
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              "default-value":
                                Number(_vm.oneCheckCriteria.filterValue) || "",
                              "options-width": "250px",
                              "tag-value": "itemId",
                              "tag-name": _vm.isZh ? "zhName" : "enName",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.value
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                            _vm.masterConditionsCarriageCode ||
                          _vm.oneCheckCriteria.filterDimension ===
                            _vm.separateConditionsCarriageCode
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              filterable: "",
                              no: "freightTerm",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ShippingTerm,
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "options-width": "250px",
                              disabled: !_vm.isEdit,
                              "tag-value": "name",
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.value
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension === _vm.eqTypes
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              filterable: "",
                              no: "eqType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_EQType,
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "options-width": "250px",
                              disabled: !_vm.isEdit,
                              "tag-name": "code",
                              "tag-value": "code",
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.value
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension === _vm.salesCode
                        ? _c("cargo-advance-select", {
                            key: "salesCode-multiple",
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "salesCode-multiple",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "sales",
                                active: true
                              },
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              filterable: "",
                              clearable: true,
                              "options-width": "250px",
                              "tag-value": "userId",
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName",
                              disabled: !_vm.isEdit,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.value
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.seaCompany
                        ? _c("cargo-advance-select", {
                            key: "seaCompany-multiple",
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "seaCompany-multiple",
                              "method-params": { seaCmp: true, active: true },
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              filterable: "",
                              clearable: true,
                              "options-width": "250px",
                              "tag-value": "cmpIdx",
                              "custom-label": function(item) {
                                return (
                                  "[" + item.shortName + "]" + item.chineseName
                                )
                              },
                              disabled: !_vm.isEdit,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.cmpIdx
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.integratedOrderType
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.oneCheckCriteria.filterValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckCriteria,
                                    "filterValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckCriteria.filterValue"
                              }
                            },
                            _vm._l(_vm.IE_TYPES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.billingPaymentMethod
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              filterable: "",
                              no: "paymentMethod-multiple",
                              "static-options": _vm.paymentMethod,
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "tag-value": "code",
                              disabled: !_vm.isEdit,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.code
                              }
                            }
                          })
                        : _vm.oneCheckCriteria.filterDimension ===
                          _vm.domesticAndForeignBills
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              filterable: "",
                              no: "domesticAndForeignBills-multiple",
                              "static-options": _vm.COUNTRY_TYPE,
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckCriteria.filterValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckCriteria.filterValue
                                    )
                                  : [],
                              "tag-value": "code",
                              disabled: !_vm.isEdit,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckCriteria.filterValue = p.code
                              }
                            }
                          })
                        : _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.oneCheckCriteria.filterValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckCriteria,
                                    "filterValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckCriteria.filterValue"
                              }
                            },
                            _vm._l(_vm.filterValues, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code + ""
                                }
                              })
                            }),
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }